import React from "react";
import { toast } from "sonner";
import { WipBanner } from "@/components/mock/MockKit";
import { V19_HTML } from "./v19html";
import "./v19shared.css";

// Renders the exact v19 mockup HTML for a preview/mock section, with a WIP banner.
// Interactive controls are neutralised to a friendly "mocked data" toast.
export function V19Page({ view, testid, onButton }) {
  const onClick = (e) => {
    if (e.target.closest("select, input, textarea")) return;
    const el = e.target.closest("button, a, [role='button'], .row-act, .q-btn");
    if (el) {
      e.preventDefault();
      if (onButton && onButton(el)) return;
      toast.message("Preview screen — mocked data, not yet wired to live APIs.");
    }
  };
  return (
    <div data-testid={testid} className="flex flex-col gap-[14px]">
      <WipBanner />
      <div className="v19">
        <div className="view on" onClick={onClick} dangerouslySetInnerHTML={{ __html: V19_HTML[view] }} />
      </div>
    </div>
  );
}
